export default function () {
  return (/iphone|ipod|ipad|Android/i).test(window.navigator.userAgent);
}



// WEBPACK FOOTER //
// ./app/features/shared/services/isSupportedDevice.js